import { render } from "./Login.vue?vue&type=template&id=358db50f&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./login.scss?vue&type=style&index=0&id=358db50f&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358db50f"]])

export default __exports__